module.exports = __webpack_public_path__ + "img/pedagogique.451115ca.png";